<template>
  <div v-if="showFengmian" class="answer-container startPageBg">
    <div class="answer-wrapper h100">
      <form ref="answerValidate" class="h100 domRelative" :model="config" @submit.prevent>
        <div class="common-body">
          <div class="home-logo">
            <img v-if="config.showLogoInd === '1'" :src="config.logoUrl | filterOssLink">
          </div>
          <div class="an-head titleArea">
            <div class="qu-type">
              <answer-type v-if="config.showTitleInd === '1'" >
                <span class="titleFontStyle" v-html="cvtLang('surveyName', config.surveyName)"></span>
              </answer-type>
            </div>
          </div>
          <div @click="next" v-if="config.startType === '01'" class="startBtn position">
            <span v-html="cvtLang('startText', config.lang.startText)"></span>
          </div>
          <div v-if="config.startType === '02'" class="startSlide" v-swipeup="next">
            <span v-html="cvtLang('slideText', config.lang.slideText)"></span>
            <i class="el-icon-arrow-up" style="margin-top: 5px;"></i>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Hammer from 'hammerjs'
export default {
  name: 'FengMianBoxAnswer',
  props: ['config', 'cvtLang'],
  data () {
    return {
      coverTitle: 'Voice of Customer',
      coverDesc: 'Your feedback is important',
      coverSubTitle: "We'd love to hear your feedback.",
      coverSubDesc: "Your thoughts matter to us. That's why we've put together a short survey for the end of your visit - it will take less than a minute to complete.",
      isPhone: false
    }
  },
  components: {},
  watch: {},
  computed: {
    /**
     * 是否显示封面
     */
    showFengmian () {
      return this.config.showFengmian === '1'
    }
  },
  methods: {
    next () {
      const hammertime = window.hammertime
      if (hammertime) {
        hammertime.get('swipe').set({
          direction: Hammer.DIRECTION_HORIZONTAL // 解锁纵向滑动事件
        })
      }
      this.$emit('next')
    }
  },
  created () {},
  mounted () {
    setTimeout(() => {
      if (document.querySelector('.titleFontStyle') && document.querySelector('.titleFontStyle').clientHeight > document.querySelector('.titleArea').clientHeight) {
        document.querySelector('.titleArea').style = 'justify-content:flex-start'
      }
    }, 0)
  }
}
</script>

<style lang="scss">
  .titleFontStyle{
    word-break: break-all;
    text-align: center;
  }
  .startPageBg{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
  .startBtn {
    height: 80px;
    width: calc(100% - 40px);
    margin: 100px 0;
    line-height: 80px;
    text-align: center;
    font-size: 30px;
    border-radius: 5px;
    font-weight: bold;
    cursor: pointer;

    &.position {
      position: absolute;
      bottom: 100px;
    }
  }
  .h100{
    height: 100%;
  }
  .domRelative{
    position: relative;
  }
  .home-logo{
    max-height: 200px;
    img {
      height: 100%;
      max-height: 200px;
    }
  }
  .common-body {
    padding: 20px;
  }
  .titleArea{
    display: flex;
    flex-direction: column;
    height: 700px;
    margin: 50px 0 50px 0;
    overflow: hidden;
    span{
      width: 100%;
      display: block;
    }
    .qu-type{
      height: auto !important;
    }
  }
  .startSlide{
    height: 80px;
    width: 100%;
    position: absolute;
    bottom: 100px;
    text-align: center;
    font-size: 30px;
    color: #ffffff;
    display: flex;
    flex-direction: column;
    align-items: center;
    img {
      margin-top: 20px;
    }
  }

  .van-dropdown-menu__bar {
    border: 2px solid rgb(220, 223, 230);
    box-shadow: none;
  }

  ._mainPage-pc {

    .answer-container {
      display: flex;
      justify-content: center;
      padding: 40px;

      .answer-wrapper {
        max-width: 900px;
        width: calc(100% - 100px);
      }
    }

    .titleArea{
      height: 500px;
      margin: 50px 0 50px 0;
    }

    .cover-title {
      font-size: 20px;

      &.sub {
        margin-top: 18px;
      }
    }

    .cover-desc {
      font-size: 16px;

      &.sub {
        margin-top: 18px;
      }
    }

    .img-container {
      margin: 20px 0;
      text-align: center;

      img {
        width: 50%;
      }
    }

    .startBtn {
      width: 200px;
      height: 48px;
      margin: 0 auto;
      line-height: 48px;
      font-size: 18px;

      &.position {
        position: absolute;
        bottom: 30px;
        left: 50%;
        margin-left: -100px;
      }
    }

    .startSlide{
      bottom: 0;
      font-size: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/FengMianBox/FengMianBoxAnswer.vue